<!-- 仓库编辑 -->
<template>
    <div id="">
        <el-form :model="submitData" ref="formMsg" label-width="80px" style="width: 100%; padding-right: 30px"
            :rules="rules">
            <div class="form-main">
                <div class="form-left">
                    <el-form-item label="仓库名称" prop="Name">
                        <el-input style="width: 100%" v-model.trim="submitData.Name"> </el-input>
                    </el-form-item>
                    <el-form-item label="国家" prop="CountryId">
                        <el-select v-model="submitData.Country" style="width: 100%" filterable clearable
                            value-key="CountryName" @change="countryChange" placeholder="请选择">
                            <el-option v-for="item in countryList" :key="item.CountryId" :label="item.CountryName"
                                :value="item"> </el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div class="form-right">
                    <el-form-item label="仓库编号" prop="Code">
                        <el-input v-model.trim="submitData.Code"> </el-input>
                    </el-form-item>
                </div>
            </div>

            <div class="form-bottom">
                <el-form-item label="省市区">
                    <el-select v-model="submitData.Province" style="width: 203px" filterable clearable
                        value-key="ProvinceName" @change="provinceChange" placeholder="请选择省">
                        <el-option v-for="item in provinceList" :key="item.ProvinceId" :label="item.ProvinceName"
                            :value="item"> </el-option>
                    </el-select>
                    <el-select v-model="submitData.City" style="width: 203px" filterable clearable value-key="CityName"
                        @change="cityChange" placeholder="请选择市">
                        <el-option v-for="item in cityList" :key="item.CityId" :label="item.CityName" :value="item">
                        </el-option>
                    </el-select>
                    <el-select v-model="submitData.Zone" style="width: 203px" filterable clearable value-key="DistrictName"
                        @change="zoneChange" placeholder="请选择区">
                        <el-option v-for="item in zoneList" :key="item.DistrictId" :label="item.DistrictName" :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="详细地址" prop="Address">
                    <el-input style="width: 100%" v-model.trim="submitData.Address"> </el-input>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input style="width: 100%" v-model.trim="submitData.Remark"> </el-input>
                </el-form-item>
            </div>
            <div class="form-main">
                <div class="form-left">
                    <el-form-item label="状态">
                        <el-select v-model="submitData.State" placeholder="请选择">
                            <el-option v-for="item in stateList" :key="item.Value" :label="item.Text" :value="item.Value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </div>
                <div class="form-right">
                    <el-form-item label="是否主仓">
                        <el-checkbox v-model="submitData.IsMain"></el-checkbox><span
                            style="color:grey;font-size: 12px;">（仅能存在一个主仓，当前主要用于自动采购）</span>
                    </el-form-item>
                </div>
            </div>
        </el-form>
        <div class="dialog-footer">
            <el-button class="btn-primary" @click="submitForm">提交</el-button>
            <el-button @click="cancel()">取消</el-button>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: ['WarehouseId'],
    components: {},
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            userMsg: userMsg,
            canRequest: true,
            countryCode: '86',
            stateList: [
                { Value: '0', Text: '正常使用' },
                { Value: '1', Text: '停用' }
            ],
            countryList: [],
            provinceList: [],
            cityList: [],
            zoneList: [],
            tagsList: [],
            submitData: {
                WarehouseId: '',
                UserId: userMsg.EmployeeId,
                Name: '',
                Code: '',
                CountryId: '54416925-01EE-40A2-A536-DA142C06F5E8',
                Country: {
                    CallCode: '86',
                    CountryId: '54416925-01EE-40A2-A536-DA142C06F5E8',
                    CountryName: '中国'
                },
                Province: {},
                ProvinceId: '',
                City: {},
                CityId: '',
                Zone: {},
                ZoneId: '',
                Address: '',
                Remark: '',
                State: '0',
                IsMain: false
            },
            rules: {
                Name: [{ required: true, message: '该项必填', trigger: 'blur' }],
                Code: [{ required: true, message: '该项必填', trigger: 'blur' }]
            }
        };
    },
    mounted() {
        this.initPage();
    },
    methods: {
        async initPage() {
            await this.getCountryList();
            // 编辑
            if (this.WarehouseId) {
                this.getWarehouse();
            } else await this.getProvinceList(this.submitData.Country.CountryId);
        },
        submitForm() {
            this.$refs.formMsg.validate(valid => {
                if (valid) {
                    if (!this.canRequest) {
                        return;
                    }
                    this.canRequest = false;
                    this.$util
                        .axiosPost({
                            url: '/api/EntpWarehouse/SaveEnterpriseWarehouse',
                            data: this.submitData,
                            hideLoading: true
                        })
                        .then(res => {
                            this.$util.successMsg('保存成功');
                            setTimeout(() => {
                                this.canRequest = true;
                            }, 1000);
                            this.$emit('closeDialog', true);
                        })
                        .catch(() => {
                            this.canRequest = true;
                        });
                }
            });
        },
        cancel() {
            this.$emit('closeDialog');
        },
        getWarehouse() {
            return new Promise((resolve, reject) => {
                this.$util
                    .axiosGet({
                        url: '/api/EntpWarehouse/GetEnterpriseWarehouse',
                        data: {
                            WarehouseId: this.WarehouseId
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        let data = res.data;
                        data.State = data.State.toString();
                        data.UserId = this.userMsg.EmployeeId;
                        data.WarehouseId = this.WarehouseId;
                        this.submitData = res.data;
                        if (data.CountryId) {
                            this.getProvinceList(data.CountryId);
                        }
                        if (data.ProvinceId) {
                            this.getCityList(data.ProvinceId);
                        }
                        if (data.CityId) {
                            this.getZoneList(data.CityId);
                        }
                        resolve();
                    });
            });
        },
        getCountryList() {
            return new Promise((resolve, reject) => {
                this.$util
                    .axiosGet({
                        url: '/api/Region/GetCountryList',
                        hideLoading: true
                    })
                    .then(res => {
                        this.countryList = res.data;
                        resolve();
                    });
            });
        },
        getProvinceList(CountryId) {
            return new Promise((resolve, reject) => {
                this.$util
                    .axiosGet({
                        url: '/api/Region/GetProvinceList',
                        data: {
                            CountryId: CountryId
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        this.provinceList = res.data;
                        resolve();
                    });
            });
        },
        getCityList(ProvinceId) {
            return new Promise((resolve, reject) => {
                this.$util
                    .axiosGet({
                        url: '/api/Region/GetCityList',
                        data: {
                            ProvinceId: ProvinceId
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        this.cityList = res.data;
                        resolve();
                    });
            });
        },
        getZoneList(CityId) {
            this.$util
                .axiosGet({
                    url: '/api/Region/GetDistrictList',
                    data: {
                        CityId: CityId
                    },
                    hideLoading: true
                })
                .then(res => {
                    this.zoneList = res.data;
                });
        },
        countryChange(value) {
            this.submitData.CountryId = value.CountryId;
            this.submitData.ProvinceId = '';
            this.submitData.Province = {};
            this.submitData.CityId = '';
            this.submitData.City = {};
            this.submitData.ZoneId = '';
            this.submitData.Zone = {};
            this.cityList = [];
            this.zoneList = [];
            this.getProvinceList(value.CountryId);
        },
        provinceChange(value) {
            this.submitData.ProvinceId = value.ProvinceId;
            this.submitData.CityId = '';
            this.submitData.City = {};
            this.submitData.ZoneId = '';
            this.submitData.Zone = {};
            this.getCityList(value.ProvinceId);
        },
        cityChange(value) {
            this.submitData.CityId = value.CityId;
            this.submitData.ZoneId = '';
            this.submitData.Zone = {};
            this.getZoneList(value.CityId);
        },
        zoneChange(value) {
            this.submitData.ZoneId = value.DistrictId;
            this.submitData.Zone = value.DistrictName;
        }
    }
};
</script>
<style lang="less" scoped>
.form-main {
    display: flex;

    >div {
        width: 50%;
    }
}

.dialog-footer {
    text-align: right;
}
</style>
